// NOTE: in order to be usable inside a .d.ts file, this enum
// must not be exported/imported explicitly. This makes it kind of global.
// It must also be a const enum, otherwise it will fail (only at runtime,
// the compiler will lie and say everything is fine)

export enum SALE_TYPE {
  DINE_IN = 100,
  TAKE_AWAY = 101,
  PICKUP = 102,
  DELIVERY = 103,
  DRIVE_THRU = 104,
  TABLE_ORDER = 105,
  WEB_ORDERING = 106,

  /**
   * (Catering Pickup)
   */
  CATERING = 107,
  APP_LANE_PICKUP = 109,
  CATERING_DELIVERY = 110,
}

export const DELIVERY_SALE_TYPES = [
  SALE_TYPE.DELIVERY,
  SALE_TYPE.CATERING_DELIVERY,
];

export const CATERING_SALE_TYPES = [
  SALE_TYPE.CATERING,
  SALE_TYPE.CATERING_DELIVERY,
];

export type SALE_TYPE_WITH_SUBS = SALE_TYPE.CATERING;
